import React, { useEffect, useState } from 'react';
import './GHGEmissions.scss';
import { withTranslation } from 'react-i18next';
import { BiSolidCheckSquare } from "react-icons/bi";
import { Button } from 'react-bootstrap';

import DownloadTemplate from './DownloadTemplate';
import ImportTemplate from './ImportTemplate';
import ViewDataCollection from './ViewDataCollection';
import useHasPermission from '../../../core/hooks/useHasPermission';

const GHGEmissions = ({ t }) => {

    const [showExport, setShowExport] = useState(true);
    const [showImport, setShowImport] = useState(false);
    const [showDataCollection, setShowDataCollection] = useState(false);
    const [selEntity, setSelEntity] = useState(null);
    const { hasDataCollectionUpdatePermission } = useHasPermission();

    const showItems = (key) => {
        switch (key) {
            case 'download':
                setShowExport(true);
                setShowImport(false);
                setShowDataCollection(false);
                break;
            case 'import':
                setShowExport(false);
                setShowImport(true);
                setShowDataCollection(false);
                break;
            case 'view':
                setShowExport(false);
                setShowImport(false);
                setShowDataCollection(true);
                break;
            default:
                setShowExport(true);
                setShowImport(false);
                setShowDataCollection(false);
                break;
        }
    }

    return (
        <div className='GHG_Box'>
            <div className='GHG_Box_head row mx-0 mb-2'>
                <div className="col-lg-4 p-0">
                    <div className="List_header">
                        <h5 className="MH">{t("Scope3DataCollection.label")}</h5>
                    </div>
                </div>

                <div className='col-lg-8 GHG_Box_head_inner p-0'>
                    <ul>
                        <li className={`${showExport ? 'active' : ''} cursor`} onClick={() => { showItems('download') }}>
                            <div className='box'>1</div>
                            <BiSolidCheckSquare />
                            {t("DownloadTemplate.label")}
                        </li>
                        <li className={`${showImport ? 'active' : ''} cursor`} 
                        hidden={!hasDataCollectionUpdatePermission()}
                        onClick={() => { showItems('import') }}>
                            <div className='box'>2</div>
                            <BiSolidCheckSquare />
                            {t("UploadFile.label")}
                        </li>
                        <li className={`${showDataCollection ? 'active' : ''} cursor`} 
                        hidden={!hasDataCollectionUpdatePermission()}
                        onClick={() => { showItems('view') }}>
                            <div className='box'>3</div>
                            <BiSolidCheckSquare />
                            {t("Save&Finalize.label")}
                        </li>
                    </ul>
                </div>
                {/* <div className='col-md-3'>
                        <ul>
                            <li>
                            <Button variant='secondary' className='px-3'>Back</Button>
                            </li>
                            <li>
                            <Button variant='primary' className='px-3'>Skip</Button>
                            </li>
                        </ul>
                </div> */}
            </div>
            <div className='GHG_Box_body'>
                {
                    showExport &&
                    <div className='Download_templateView'>
                        <DownloadTemplate gotoNext={(val) => { showItems(val) }} />
                    </div>
                }

                {
                    showImport &&
                    <div className='GHG_UploadBox'>
                        <ImportTemplate entity={(ent) => { setSelEntity(ent) }} gotoNext={(val) => { showItems(val) }} />
                    </div>
                }
                {
                    showDataCollection &&
                    <div className='Verify_dataBox '>
                        <ViewDataCollection entity={selEntity} />
                    </div>
                }

            </div>
        </div>
    );
};

export default withTranslation()(GHGEmissions);